export const formRevision = context => context?.offline_authorization?.form_revision || context?.offline_authorization?.template_version || null;

const fieldShape = field => [field?.id ?? null, field?.name ?? null, field?.slug ?? null, field?.label ?? null,
    field?.type ?? null, field?.field_type ?? null, field?.prefix ?? null,
    Array.isArray(field?.subgroup_items) ? field.subgroup_items.map(fieldShape) : null,
    Array.isArray(field?.fields) ? field.fields.map(fieldShape) : null];
const meaningful = value => value !== null && value !== undefined && value !== '' && (typeof value !== 'object' || Object.values(value).some(meaningful));

export function formUpdateCompatibility(current, next) {
    if (!current) return { safe: true, preserved: true };
    const previousIds = current.visita?.form_template_ids || [], nextIds = next.visita?.form_template_ids || [];
    const oldFields = current.template?.fields || [], newFields = next.template?.fields || [];
    const preserved = previousIds.every((id, index) => Number(nextIds[index]) === Number(id))
        && oldFields.every((field, index) => JSON.stringify(fieldShape(field)) === JSON.stringify(fieldShape(newFields[index])));
    if (preserved) return { safe: true, preserved: true };
    const visit = current.visita || {};
    const hasWork = Object.values(visit.responses || {}).some(value => meaningful(value && typeof value === 'object' && 'value' in value ? value.value : value))
        || Object.keys(visit.custom_subgroup_names || {}).length > 0
        || (visit.dynamic_group_items || []).some(group => Number(group.additional_count) > 0)
        || ['imagenes', 'adjuntos_documentacion', 'firma', 'firma_path', 'observacion', 'cuerpo_informe_personalizado',
            'instance_states', 'instance_owners', 'excluded_from_report_fields', 'excluded_subgroup_instances',
            'excluded_manual', 'excluded_auto', 'hidden_response_fields', 'additional_fields'].some(key => meaningful(visit[key]));
    return hasWork ? { safe: false, preserved: false, reason: 'structure_changed' } : { safe: true, preserved: false };
}

const editors = new Map();
const key = (scope, id) => `${scope}:${Number(id)}`;
export function registerVisitaFormEditor(scope, id, editor) {
    const identity = key(scope, id);
    editors.set(identity, editor);
    return () => { if (editors.get(identity) === editor) editors.delete(identity); };
}
export function getVisitaFormEditor(scope, id) { return editors.get(key(scope, id)); }
export const VISITA_FORM_UPDATE = 'visita:form-context-update';
export const VISITA_FORM_EDITOR_IDLE = 'visita:form-editor-idle';
const blocked = new Map();
export function getFormBlockedVisits(scope) { if(!blocked.has(scope))blocked.set(scope,new Set());return blocked.get(scope); }
export function markVisitaFormUpdate(scope, id, result) {
    const visits=getFormBlockedVisits(scope);
    if(result.reason==='form_update_pending'&&['structure_changed','revoked','download_failed'].includes(result.pendingReason))visits.add(Number(id));
    else visits.delete(Number(id));
}
export function emitVisitaFormUpdate(scope, visitaId, result, target = typeof window === 'undefined' ? null : window) {
    markVisitaFormUpdate(scope,visitaId,result);
    target?.dispatchEvent(new CustomEvent(VISITA_FORM_UPDATE, { detail: { scope, visitaId: Number(visitaId), status: result.reason === 'form_update_pending' ? 'pending' : 'applied', reason: result.pendingReason || null, revision: formRevision(result.context) } }));
}
